import React from 'react';
import { AlertCircle, CheckCircle, Info, XCircle, X } from 'lucide-react';

const variants = {
  info: {
    container: 'bg-blue-50 border-blue-200 text-blue-900',
    icon: Info,
    iconColor: 'text-blue-500',
  },
  success: {
    container: 'bg-green-50 border-green-200 text-green-900',
    icon: CheckCircle,
    iconColor: 'text-green-500',
  },
  warning: {
    container: 'bg-yellow-50 border-yellow-200 text-yellow-900',
    icon: AlertCircle,
    iconColor: 'text-yellow-500',
  },
  error: {
    container: 'bg-red-50 border-red-200 text-red-900',
    icon: XCircle,
    iconColor: 'text-red-500',
  },
};

export const Alert = ({
  children,
  title,
  variant = 'info',
  dismissible = false,
  onDismiss,
  className = '',
}) => {
  const config = variants[variant];
  const Icon = config.icon;

  return (
    <div className={`rounded-lg border p-3 ${config.container} ${className}`}>
      <div className="flex items-start gap-2">
        <Icon className={`h-5 w-5 flex-shrink-0 ${config.iconColor}`} />
        
        <div className="flex-1">
          {title && <h4 className="font-semibold mb-0.5 text-sm">{title}</h4>}
          <div className="text-sm">{children}</div>
        </div>
        
        {dismissible && (
          <button
            onClick={onDismiss}
            className="flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="h-4 w-4" />
          </button>
        )}
      </div>
    </div>
  );
};
